import { Card } from "@shared/components/ui/card";
import { Badge } from "@shared/components/ui/badge";
import { CalendarCheck2, MapPinIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { STATUS_OPTIONS, STATUS_COLORS } from "@shared/utils/constants";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import AddTrackingNumber from "./AddTrackingNumber";
import { useAuth } from '@features/auth/contexts/AuthContext';
import { PackagesActionsDropdownMenu } from "@/features/packages/components/MenuActions";
import { Separator } from "@shared/components/ui/separator";
import InvoiceBadge from "./InvoiceBadge";
export default function PackageRowCard({ pkg }) {
  const { customer, status, totalAmount, createdAt } = pkg;
  const navigate = useNavigate();
  const auth = useAuth();

  const { t } = useTranslation();
  return (
    <Card className="flex items-center justify-between  shadow-sm transition-transform duration-300 hover:scale-99 cursor-pointer hover:bg-background/10">
      <div className="px-2">
        {pkg.trackingNumber ? (
          <p className="truncate p-2 font-bold">
            {auth.isAdmin
              ? pkg.trackingNumber
              : pkg.trackingNumber?.replace("MA", "SP-")}
          </p>
        ) : (
          <>{auth.isAdmin && <AddTrackingNumber packageId={pkg._id} />}</>
        )}
      </div>
      <div className="w-full">
        <div className="flex text-sm lg:text-base flex-row gap-2 items-center justify-between p-3">
          <div className="flex items-center justify-between space-x-2">
            <p className="text-sm lg:text-base font-semibold text-nowrap truncate">
              {customer.phone}{" "}
              <span
                className="hidden lg:inline-block"
                onClick={() => {
                  navigate(`/packages/${pkg._id}/view`);
                }}
              >
                {" "}
                | {customer?.name}
              </span>
            </p>
          </div>
          <div
            className="flex gap-2 justify-end items-center w-full"
            onClick={() => {
              navigate(`/packages/${pkg._id}/view`);
            }}
          >
            {totalAmount.toFixed(2)} {t("main.currency")}
            <div className="flex gap-2 w-fit">
              <div className="hidden lg:flex items-center space-x-2 text-muted-foreground rounded-md bg-muted/50 px-2 py-1 text-center gap-1">
                <CalendarCheck2 className="h-4 w-4" />
                <span className="text-sm">
                  {format(createdAt, "dd/MM/yyy")}
                </span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground rounded-md bg-muted/50 px-2 py-1 text-center gap-1">
                <MapPinIcon className="h-4 w-4" />
                <span className="text-sm">{customer?.city}</span>
              </div>
            </div>
            <div className="flex items-center space-x-2 truncate gap-1">
              <InvoiceBadge pkg={pkg} />
              <Badge
                className={`${STATUS_COLORS[status]} hover:${STATUS_COLORS[status]}`}
              >
                {t(STATUS_OPTIONS[status])}
              </Badge>
            </div>
            {auth.isAdmin && (
              <div className="flex items-center gap-2 truncate">
                <Separator orientation="vertical" className="h-6 mx-2" />
                {pkg?.user?.brandName}
              </div>
            )}
          </div>
        </div>
      </div>
      <PackagesActionsDropdownMenu pkg={pkg} />
    </Card>
  );
}
